import { Response } from 'express';

import { TAppThunkDispatch, TGetState } from '~/src/store';
import { fetchClientInfo } from '~/src/store/actions/clientInfo';

/**
 * Получаем данные для ЛК авторизованного
 */
/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export function getClientAll(response?: Response, agreementNumber?: string) {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const { auth } = getState();
        const { clientPaymentLoaded, clientPaymentFetching, clientPersonal } = auth;

        // Не выполняем запрос если данные были загружены ранее
        if (clientPaymentLoaded || clientPaymentFetching || clientPersonal !== null) {
            return;
        }

        await Promise.resolve(
            dispatch(fetchClientInfo(response, agreementNumber)),
        );
    };
}
